// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".centered-row{display:flex;height:100%;align-items:center}.button-container .btn{margin-right:10px}.centered-buttons{display:flex;justify-content:center}", ""]);
// Exports
module.exports = exports;
